import type { FaireProductEntity } from "../../entity_types/product";

export const p_tsh6bg44y4: FaireProductEntity = {
  token: "p_tsh6bg44y4",
  type: "product",
  name: "4pc Sunstone Spheres ~ Polished Crystals & Minerals ~ Gifts",
  brandToken: "b_t2bh3wmq82",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4cdb959bf0626f68c7b85e22b5cc85b956c749eaa37fc833d06a7adadf896070.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c52e4a67e6bb48b6aeb2cd449c53caaee9217688c517c0650a7b9e09dacbad1.jpeg",
    "https://cdn.faire.com/fastly/4e886087640e498835bb4d4e94afd1cb0703800ef00ccd4c4a9848e05b446d94.jpeg",
    "https://cdn.faire.com/fastly/c070f0e393a4efd7ab6fc0f94ac7e44d67889d378ce612d4d4c727931f501d2c.jpeg",
    "https://cdn.faire.com/fastly/4a121441f1c6d9576c18c0e99f6f750dd3955a806f392ca2a0a0c06114efa857.jpeg",
    "https://cdn.faire.com/fastly/01f70bd5c67ddfdaf20006500f396307b422548e5b7ff2fe06477c175cc621fb.jpeg",
    "https://cdn.faire.com/fastly/54a6155816cd2282c261b9e513c534817cefa4ef6d5aa1aa744db1a242e6adea.jpeg",
  ],
  priceDollars: 103.93,
  description:
    "This listing is for 4 pieces of Sunstone from India.\n\nSunstone is known as a stone of joy, vitality, and personal empowerment. Often associated with the sacral and solar plexus chakras, it is believed to inspire self-confidence, increase motivation, and bring a sense of warmth and positivity. This radiant stone is cherished for dispelling negativity, enhancing self-worth, and encouraging a bright outlook on life. \n\nScientifically, sunstone is a feldspar mineral with the chemical formula (Na,Ca)Al₁₋₂Si₃₋₂O₈. It displays aventurescence, a sparkling effect caused by light reflecting off tiny inclusions of hematite or goethite. Sunstone has a Mohs hardness of 6 to 6.5. Historically, it was revered by ancient Nordic cultures, where it was believed to have been used as a navigational tool due to its ability to reflect sunlight, even on cloudy days.",
  tags: [],
  msrpDollars: 207.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:34.965Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
